import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { ErrorNumbers } from "./ErrorNumbers";
import { ErrorPageContent } from "./ErrorPageContent";

export function Error401Content(): ReactElement {
  const { t } = useTranslation("features.errorPages");

  return (
    <ErrorPageContent
      graphic={<ErrorNumbers>401</ErrorNumbers>}
      title={t("Error401.title")}
      description={t("Error401.description")}
      buttonTitle={t("Error401.buttonTitle")}
      onButtonClick={() => (window.location.href = "/")}
    />
  );
}
